import axios from 'axios';

// The expense report page is public, so it must not use the shared client:
// that client refreshes the session and redirects to /login on 401.
const rawBackendUrl = process.env.REACT_APP_BACKEND_URL;
const backendUrl = rawBackendUrl && !['undefined', 'null'].includes(rawBackendUrl)
  ? rawBackendUrl.replace(/\/$/, '')
  : '';
const baseURL = process.env.NODE_ENV === 'development' || !backendUrl
  ? '/api/public/expense-reports'
  : `${backendUrl}/api/public/expense-reports`;

const publicApi = axios.create({ baseURL, timeout: 45000 });

const withKey = (accessKey) => (accessKey ? { headers: { 'X-Report-Key': accessKey } } : {});

export const getExpenseReportConfig = () => publicApi.get('/config');

export const getExpenseReportSuppliers = (accessKey) => publicApi.get('/suppliers', withKey(accessKey));

export const lookupExpenseInvoice = (code, accessKey) =>
  publicApi.post('/lookup', { code }, withKey(accessKey));

export const createExpenseReport = (formData, accessKey) =>
  publicApi.post('', formData, withKey(accessKey));

export const getExpenseReportError = (error) => ({
  code: error?.response?.data?.detail?.code || (error?.response ? 'unknown' : 'network'),
  message: error?.response?.data?.detail?.message || error?.message || '',
  status: error?.response?.status,
});
